import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const adminAiChatApi = createApi({
  reducerPath: 'admin-ai-chat',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['AiChat'],
  endpoints: (builder) => ({
    getAiChats: builder.query({
      query: ({ pageno = 1, limit = 50 } = {}) => ({
        url: `/admin/ai-chats?pageno=${pageno}&limit=${limit}`,
        method: 'GET',
      }),
      providesTags: ['AiChat'],
    }),
    getAiChat: builder.query({
      query: (id) => ({
        url: `/admin/ai-chat/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'AiChat', id }],
    }),
    sendAiChatMessage: builder.mutation({
      query: (body) => ({
        url: `/admin/ai-chat/message`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AiChat'],
    }),
    deleteAiChat: builder.mutation({
      query: (id) => ({
        url: `/admin/ai-chat/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AiChat'],
    }),
  }),
});

export const {
  useGetAiChatsQuery,
  useLazyGetAiChatQuery,
  useSendAiChatMessageMutation,
  useDeleteAiChatMutation,
} = adminAiChatApi;
